import axios from 'axios'
export default {
    bimhelper_getColorUtility(thewin) {
        if (thewin.BIMe) {
            return thewin.BIMe.control.BIMeUtility;
        } else {
            return thewin.model.BIM365API.Controller;
        }
    },
    DeepCopy(arr) {
        let str = JSON.stringify(arr);
        return JSON.parse(str);
    },
    //数字千分位分隔符
    thousandBitSeparator(num) {
        let reg2 = /(?!^)(?=(\d{3})+$)/g;
        if (!num || num === '-') {
            return num;
        }
        let str = num.toString().split('.')
        str[0] = str[0].replace(reg2, ',');
        return str[0];
    },
    //文件icon类型
    getFileIcontype(filetype) {
        if (!filetype) {
            return;
        }
        if (filetype.indexOf("application/") > -1) {
            let type = filetype.split('/')
            type = type[1]
            if (type === 'vnd.ms-excel' || type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                return 'excel';
            } else if (type === 'msword' || type === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
                return 'word';
            } else if (type === 'vnd.ms-powerpoint' || type === 'vnd.openxmlformats-officedocument.presentationml.presentation') {
                return 'ppt';
            } else if (type === 'x-zip-compressed') {
                return 'zip';
            } else if (type === 'pdf') {
                return 'pdf';
            } else {
                return 'none';
            }
        } else if (filetype.indexOf("text/plain") > -1) {
            return 'txt';
        }
    },
    //下载图片
    downloadIamge(imgsrc, name) { //下载图片地址和图片名
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
            let canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            let url = canvas.toDataURL("image/png");
            let a = document.createElement("a");
            let event = new MouseEvent("click");
            a.download = name || "photo.png";
            a.href = url;
            a.dispatchEvent(event);
        };
        image.src = imgsrc;
    },
    //下载文件流
    downloadFileStream(blod, filename) {
        const blob = new Blob([blod]);
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob);
        downloadElement.target = '_blank';
        downloadElement.href = href;
        downloadElement.download = filename;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
    },
    //统一添加请求头token
    getTokenRequest() {
        return axios.create({
            headers: { "token": window.localStorage.getItem("Token") }
        });
    },
    //获取传入参数值
    getQueryVariable(variable) {
        let query = window.location.hash.split('?')[1]
        if(query) {
            let vars = query.split('&')
            for (let i = 0; i < vars.length; i++) {
                let pair = vars[i].split('=')
                if (pair[0] === variable) {
                    return pair[1]
                }
            }
        }
        return ''
    },
    //图表字体、间距自适应
    fitChartSize(size, defalteWidth = 1920){
        let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        if(window.frameElement != null) { //iframe
            clientWidth = window.frameElement.clientWidth
        }
        if (!clientWidth) return size
        let scale = (clientWidth / defalteWidth)
        if(scale > 1) {
            scale = 1
        }
        return Number((size * scale).toFixed(3))
    }
}